import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from "@angular/core";
import { CommonService } from '../../services/common.service';
import { UtilService } from '../../services/util.service';
import { AppService } from "../../shared/services/app.service";
import { PreferenceService } from "../../shared/services/preference.service";
import { RolePermissionService } from "../../shared/services/role-permission.service";
import { StorageService } from "../../shared/services/storage.service";
import { BaseService } from "../../shared/services/base.service";
import { LoaderService } from "../../services/loader.service";
import { PrintService } from "../../shared/services/print.service";
import { AlertsService } from "../../services/alerts.service";
import { SmartModalService } from "../../services/smart-modal.service";
declare var jQuery: any;
@Component({
    selector: 'data-table',
    templateUrl: './simple-data-table.component.html',
    styleUrls: ['./simple-data-table.component.scss'],
    standalone: false
})
export class SimpleDataTableComponent implements OnInit {
  @Input() fields: any;
  @Input() data: any;
  @Input() viewAction: any
  @Input() storageKey: any;
  @Input() patientData: any;
  @Input() disableCardView: boolean = false;
  @Output() emitValue = new EventEmitter<any>();
  @Output() emitDate = new EventEmitter<any>();
  @Output() emitCheck = new EventEmitter<any>();
  @Output() emitInpSearch = new EventEmitter<any>();
  @Output() removeValue = new EventEmitter<any>();
  @Output() ddValueChanged = new EventEmitter<any>();
  @Output() cancelValue = new EventEmitter<any>();
  @Output() editValue = new EventEmitter<any>();
  @Output() byPass = new EventEmitter<any>();
  @Output() templateForm = new EventEmitter<any>();
  @Input() view_care_type: boolean = true;
  // @Output() selectedSwitchEmit = new EventEmitter<any>();
  actionClass: boolean = false;
  selectedIndices: Boolean[];
  flag: boolean;
  viewAll: boolean = true;
  selectedSwitch: Boolean[];
  selectedItems: number = 0;
  count: number = 0;
  selectedItemsData = [];
  selectedSwitchData = [];
  priorityApi: boolean = true;
  checkedHeader: boolean = false;
  toolTipInfo_view: any = "";
  @Output() selectedItemsEmit = new EventEmitter<any>();
  IsUserprint: boolean = false

  constructor(
    public utilService: UtilService,
    public rolePermission: RolePermissionService,
    public elementRef: ElementRef,
    private appService: AppService,
    public preferenceService: PreferenceService,
    public storageService?: StorageService,
    public commonService?: CommonService,
    public baseService?: BaseService,
    public loader?: LoaderService,
    public printService?: PrintService,
    public alertService?: AlertsService,
    public smartModalService?: SmartModalService
  ) { }

  ngOnInit() {
    if (this.storageKey != undefined && this.storageKey != "") {
      this.storageService.getData(this.storageKey, (val) => {
        if (val.length != undefined && val != false) {
          for (let i in val) {
            this.fields[i].hidden = val[i].hidden
            this.fields[i].selected = val[i].selected
          }
          // this.fields = val;
        }
        else {
          this.getTableConfig((dataa) => {
            if (dataa != null && dataa.length) {
              for (let i in dataa) {
                this.fields[i].hidden = dataa[i].hidden
                this.fields[i].selected = dataa[i].selected
              }
              // this.fields = dataa;
            }
          }
          )
        }
      }
      )
    }
    if (this.fields != undefined && this.fields.length != undefined) {
      this.fields.forEach(element => {
        if (element['type'] == 'action') {
          this.actionClass = true;
        } else if (element['type'] == "BulkAction") {
          this.count = this.data.filter(x => (x.status == 'Pending' && this.checkCondition(element.condition, x))).length
        }
      });
      this.selectedIndices = [];
      this.selectedSwitch = [];
      if (this.appService.getAppData().AUTO_COLUMNS != undefined && this.appService.getAppData().AUTO_COLUMNS.length > 0 && this.appService.getUniversalConfig('multi_care_type') && this.view_care_type) {
        for (let index = 0; index < this.appService.getAppData().AUTO_COLUMNS.length; index++) {
          var singleAuto = this.appService.getAppData().AUTO_COLUMNS[index];
          this.fields = this.fields == undefined ? [] : this.fields;
          singleAuto['order'] = this.fields.find(x => x.type == "multiple_action") != undefined ? this.fields.find(x => x.type == "multiple_action").order - 1 : (this.fields.find(x => x.type == "action") != undefined ? this.fields.find(x => x.type == "action").order - 1 : 1);
          singleAuto['selected'] = true;
          this.fields = this.fields.concat([singleAuto]);
          console.log("this.fields ", this.fields);
        }
      }
      this.fields.sort(function (a, b) { return a.order - b.order })
    }
  }

  setInputResult(e, index) {
    this.emitInpSearch.emit({ value: e, index: index })
  }
  togglePerformingDoctorSearch(index) {
    if (this.data && this.data[index]) {
      this.data[index]['_prevPerformDoctorState'] = {
        performing_doctor: this.data[index]['performing_doctor'],
        serviceDoctorId: this.data[index]['serviceDoctorId'],
        participant: this.data[index]['participant'],
        band_type_name: this.data[index]['band_type_name'],
        band_type_code: this.data[index]['band_type_code'],
        specialityData: this.data[index]['specialityData'],
        serviceSpeciality: this.data[index]['serviceSpeciality']
      };
    this.data[index]['showInputSearch'] = true;
    }
  }

  cancelPerformingDoctorSearch(index) {
    if (this.data && this.data[index]) {
      const prev = this.data[index]['_prevPerformDoctorState'];
      if (prev) {
        this.data[index]['performing_doctor'] = prev.performing_doctor;
        this.data[index]['serviceDoctorId'] = prev.serviceDoctorId;
        this.data[index]['participant'] = prev.participant;
        this.data[index]['band_type_name'] = prev.band_type_name;
        this.data[index]['band_type_code'] = prev.band_type_code;
        this.data[index]['specialityData'] = prev.specialityData;
        this.data[index]['serviceSpeciality'] = prev.serviceSpeciality;
        delete this.data[index]['_prevPerformDoctorState'];
      }
      this.data[index]['showInputSearch'] = false;
    }
  }
  removeData(i, a, value) {
    if (a.emitValue == undefined || a.emitValue == false) {
      this.data.splice(i, 1);
      this.removeValue.emit({ "index": i });
    } else if (a.emitValue == true && a.splitValue == true) {
      this.data.splice(i, 1);
      value['index'] = i;
      this.removeValue.emit(value);
    } else {
      this.removeValue.emit(value);
    }
  }
  cancelData(i) {
    this.cancelValue.emit({ "index": i });
  }
  CheckChanged(event, index) {
    this.emitCheck.emit({ value: event, index: index })
  }
  onChangeDate(event, index) {
    let date = event.startDate;
    this.emitDate.emit({ value: date, index: index })
  }
  onKey(event, index, fieldVal?) {
    if (this.rolePermission.checkdecimalConfig() && event.target.value) {
      let _value = (+event.target.value).toFixed(this.rolePermission.checkdecimalConfig());
      this.emitValue.emit({ value: _value, index: index, field: fieldVal })
    } else {
      this.emitValue.emit({ value: event.target.value, index: index, field: fieldVal })
    }
  }

  toolTipInfo(d: any) {
    this.toolTipInfo_view = d.toolTip
  }

  checkdecimal(value, index, event) {
    if (this.rolePermission.checkdecimalConfig() && event.target.value) {
      //this.data[index][value] = (+event.target.value).toFixed(this.rolePermission.checkdecimalConfig())
      let mptArr = [];
      this.data.forEach((elem, i) => {
        if (i === index && event.target.value.split(".")[1] && event.target.value.split(".")[1].length >= this.rolePermission.checkdecimalConfig()) {
          elem[value] = (+event.target.value).toFixed(this.rolePermission.checkdecimalConfig());
          mptArr.push(elem);
        } else {
          mptArr.push(elem);
        }
      })
      this.data = mptArr;
    } else if (event.target.value) {
      this.data[index][value] = +event.target.value
    } else {
      this.data[index][value] = event.target.value
    }
  }

  editData(data: any, action: any) {
    if (action != undefined && action.action == "confirm") {
      this.editValue.emit({ data: data, action: action });
    } else {
      this.editValue.emit(data);
    }
  }

  templateData(data: any) {
    this.templateForm.emit(data);
  }

  rowData(data: any) {
    this.byPass.emit(data.data);
  }

  getValue(field: any, item: any) {
    let fn;
    try {
      if (item.hasOwnProperty(field.format.split(".")[1].split("[0]")[0]))
        return eval(field.format)(item)
      else
        return eval(field.format)(item)
    }
    catch (error) {

    }
  }

  getArrayValue(field: any, item: any) {
    let val = [];
    let fn;  // Dont remove it, used for format when arrow fn is removed
    if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {
      for (let i = 0; i < item[field.name].length; i++) {
        let arrayItem = item[field.name][i];
        let e = eval(field.format)(arrayItem);
        if (e) { val.push(e); }
      }
      return val;
    }
  }

  showEdit(condition: any, item: any) {
    if (sessionStorage && sessionStorage.currentData != undefined)
      var sessionData = JSON.parse(sessionStorage.currentData);
    if (condition && condition.includes("is_template_filled") && sessionData && sessionData.fitment_status && sessionData.fitment_status.toLowerCase() == "not required for ehc")
      item['fitment_status'] = sessionData.fitment_status;//for EHC, check summary is filled or not
    if (condition)
      return eval(condition)
    else
      return true
  }

  returnStyle(field, item) {
    for (let i = 0; i < field.condition.length; i++) {
      if (eval(field.condition[i].expression)) {
        return field.condition[i].style
      } else {
        return { "color": "grey" }
      }
    }
  }

  returnFieldType(type: any) {
    if (type == 'action' || type == 'multiple_action' || type == 'BulkAction')
      return false
    else
      return true
  }

  checkCondition(condition, data) {
    if (!data)
      return
    var item = data;
    if (condition) {
      var c = [];
      for (let i = 0; i < condition.length; i++) {
        c.push(condition[i].expression)
      }
      if (c.length > 1)
        return eval(c.join(" && "))
      else
        return eval(c[0])
    } else {
      return true;
    }
  }
  toggleVisibility(event, field) {
    field.hidden = !field.hidden;
    const check = event.target.checked;
    if (check === false) {
      field.selected = false;
      this.viewAll = false;
    }
    else {
      field.selected = true;
      for (let i = 1; i < this.fields.length; i++) {
        if (this.fields[i].selected == true) {
          this.flag = true;
        } else {
          this.flag = false;
          break;
        }
      }
      if (this.flag) {
        this.viewAll = true;
      } else {
        // this.config.viewAll = false;
      }
    }
    // this.gridData.emit(this.fields);
    this.saveTableConfig(field.name);
    // this.removeDragListner();
    // this.tableInitalized = false;
    // this.computeColumnPercentages()
  }
  saveTableConfig(name: any = true) {
    this.getTableConfig((saveData) => {
      saveData = (saveData) ? saveData : {};
      if (typeof name == 'boolean') {
        this.fields.forEach((item, index) => {
          if (item.name != undefined && item.name != "") {
            //this.config.fieldOrder[item.name] = index;
            name = item.name;
            saveData[name] = (saveData[name] == undefined) ? {} : saveData[name];

            //saveData[name].order = index;

            if (item.hidden != undefined) {
              saveData[name].hidden = item.hidden;
            }
          }

        });
      } else {
        var item: any = false;
        //var index = this.config.fieldOrder[name];
        // if (this.fields[index] != undefined) {
        //   item = this.fields[index];
        // }
        // if (item) {
        //   saveData[name] = (saveData[name] == undefined) ? {} : saveData[name];
        //   saveData[name].order = index;
        //   if (item.hidden != undefined) {
        //     saveData[name].hidden = item.hidden;
        //   }
        // }
      }
      this.saveTableConfigData(saveData);
    });
  }
  saveTableConfigData(data, callback: any = false) {
    var key = this.storageKey;
    this.preferenceService.saveTableConfigData(key, this.fields, callback);
  }
  getTableConfig(callback) {
    var key = this.storageKey;
    this.preferenceService.getUserPreferenceConfig(key, (data) => {
      //localStorageData = data;
      callback(data);
    });
  }
  resetDefaultConfig() {
    for (let val of this.fields) {
      val.hidden = false;
    }
    this.delteConfigData();
    this.hidePopUp();
  }
  hidePopUp() {
    jQuery("popover-container").hide();
  }
  delteConfigData() {
    this.resortFields();
  }
  changeDdVal(e, field, i) {
    this.ddValueChanged.emit({ value: e, field: field, index: i })
  }
  resortFields() {
    this.fields.sort((a, b) => { return a.order - b.order });
    this.HidetoggleVisibility(true, true);
  }

  HidetoggleVisibility(event, auto = false) {
    const checked = event;
    //this.config.fieldOrder = {};
    let filteredData = this.fields.filter(x => { return x.type != "BulkAction" }).filter(y => { return y.type != "switch" }).filter(z => { return z.type != "icon" })
    filteredData.forEach((item, index) => {
      // if (item.name != undefined && item.heading != "" && item.heading) {
      //     this.config.fieldOrder[item.name] = index;
      // }
      if (index == 0) {
        item.disabled = true;//it will raise an error when column reordering
      } else {
        item.disabled = false;
        if (checked) {
          item.selected = true;
          item.hidden = false;
        }
      }
      if (item.hidden == undefined) {
        item.hidden = false;
        item.selected = true;
      }
    });
    if (checked === false) {
      filteredData.forEach((item, index) => {
        if (item.heading != '') {
          if (index == 0) {
            item.hidden = false;
            item.selected = true;
          } else {
            item.hidden = true;
            item.selected = false;
          }
        }
      });
      this.viewAll = false;
    } else {
      this.viewAll = true;
    }
    if (!auto) {
      this.saveTableConfig();
      //this.removeDragListner();
      //  this.tableInitalized = false;
    }
  }

  onAllChecked(check: any, condition: any) {
    if (check == true) {
      this.selectedItems = this.data.filter(x => (x.status == 'Pending' && this.checkCondition(condition, x))).length;
      this.data.filter(x => (x.status == 'Pending' && this.checkCondition(condition, x))).forEach((element, index) => {
        if (this.selectedIndices[element.id] != true)
          this.selectedItemsData.push(element);
        if (this.selectedIndices[element.id] == null) {
          this.selectedIndices[element.id] = true;
        } else {
          this.selectedIndices[element.id] = true
        }
      });
      this.checkedHeader = true;
    } else {
      this.selectedItems = 0;
      this.checkedHeader = false;
      this.selectedItemsData = [];
      this.selectedIndices = [];
    }
  }

  checkedItem(value: any, i: any, data: any) {
    if (value == true) {
      this.selectedItems++
      this.selectedIndices[data.id] = true;
      this.selectedItemsData.push(data);
      if (this.selectedItems == this.count) {
        this.checkedHeader = true;
      }
    } else {
      this.selectedItems--
      delete this.selectedIndices[data.id];
      this.selectedItemsData.splice(this.selectedItemsData.indexOf(this.selectedItemsData.find(x => x.id == data.id)), 1);
      this.checkedHeader = false;
    }
  }

  checkedSwitch(value: any, i: any, data: any) {
    if (value == true) {
      this.selectedSwitch[value.id] = true;
      this.data.find(x => x.id == data.id)['isSelected'] = true;
    } else {
      delete this.selectedSwitch[value.id];
      this.data.find(x => x.id == data.id)['isSelected'] = false;
    }
  }

  onBulkActionClicked() {
    this.selectedItemsEmit.emit(this.selectedItemsData);
    // this.selectedSwitchEmit.emit(this.selectedSwitchData)
  }

  checkedStatus(condition) {
    if (this.data.filter(x => (x.status == 'Pending' && this.checkCondition(condition, x))).length == 0) {
      return true
    } else {
      return false
    }

  }

  checkpermision(a) {
    if (a.hasOwnProperty("action_name") && a.hasOwnProperty('permission_required')) {
      if (a.permission_required) {
        return this.rolePermission.checkAccessPermission(a.action_name, a.resource, a.application)
      } else {
        return true
      }
    } else {
      return true
    }

  }
  getClass(field, item) {
    let class_: string = "";
    if (field != undefined && field.name && (field.name == 'priority' || field.name == 'priority_name' || field.name == 'servicePriority' || field.name == "visitType")) {
      if (this.priorityApi) {
        this.commonService.getPriorityColor();
        this.priorityApi = false
      }
      let priorityData = this.commonService.servicePriorityList != undefined ? this.commonService.servicePriorityList.find(x => (x.serviceType_code == item.serviceType_code) && (x.service_priority_id == (item.priority_code || item.priorityCode || item.priority || item.priority_id || item.servicePriorityCode))) : '';
      return class_ = priorityData != undefined && priorityData.color_Id != undefined ? priorityData.color_Id : '';
    }
    else if (field != undefined && field.class_conditions != undefined && field.class_conditions && field.class_conditions.length > 0 && !(field.name == 'priority' || field.name == 'priority_name' || field.name == 'servicePriority' || field.name == "highestPriority")) {
      return this.setclass(field.class_conditions, item, class_);
    }
    if(item && item.is_duplicate && field && field.duplicate_class)
     return class_ = "duplicate_order"
  }

  setclass(field, item, class_) {
    if (item != undefined) {
      for (let val of field) {
        if (eval(val.expression)) {
          return class_ = val.class != undefined ? val.class : val.class_name ? val.class_name : '';
        }
      }
    }
  }

  getDDOptionsVal(option, field) {
    if (field.key && option) {
      return option[field.key];
    } else {
      return option[field.name];
    }
  }
  async print(event?, value?, callback?) {
    try {
      this.loader.showSpinner();
      const { isUserPrint, file_data } = event || {};
      const key = this.patientData?.id;
      // Note: For the second occurrence, the data is stored in both event.file_data.args and event.file_data.filter Start
      if (event?.resetDataSource?.args && !event?.file_data?.args?.includes('!!!')) {
        event.file_data.args = event.resetDataSource.args;
      }
      if (event?.resetDataSource?.filter && !event?.file_data?.filter?.includes('!!!')) {
        event.file_data.filter = event.resetDataSource.filter;
      }
      if (event?.file_data?.contentType?.includes?.('application')) {
        event.file_data.contentType = 'pdf';
      }
      // Note: For the second occurrence, the data is stored in both event.file_data.args and event.file_data.filter End //
      if (event?.file_data?.args !== undefined) {
        event.file_data.args = this.baseService.buildDyanamicStr(event.file_data.args, { data: { ...value, id: key } });
        event.file_data.args = this.baseService.appendEhrFacilityIdArg(event.file_data.args, { data: { ...value, id: key } });
      }
      if (event?.file_data?.filter !== undefined) {
        event.file_data.filter = this.baseService.buildDyanamicStr(event.file_data.filter, { data: { ...value, id: key } });
      }
      if (typeof file_data?.resource === "string" && file_data.resource.includes("/print")) {
        file_data.resource = file_data.resource.replace(/\/print/g, "");
      }
      this.baseService.handleFile(event.file_data, (fileData) => {
        try {
          if (fileData) {
            event.file_data['key'] = value?.serviceItemId;
              if (typeof file_data?.resource === "string" && file_data.args?.includes("contentType:application/pdf,")) {
              file_data.args = file_data.args.replace("contentType:application/pdf,", "").replace(/contentType:pdf(?!,)/, "contentType:pdf");
              }
              if (event?.file_data?.contentType?.includes('application')) {
                event.file_data.contentType = "pdf";
              }
              this.printService.handleFileReponse(event.file_data, 'print', fileData, callback);
          } else {
            this.alertService.error('server error');
          }
        } finally {
          this.loader.hideSpinner();
        }
      });
  
    } catch (error) {
      this.loader.hideSpinner();
      this.alertService.error(error?.message || 'Unexpected error');
    }
  }
  


}
